import axios from 'axios';
import { serviceBaseUrl } from './constants';

export const sendOtpService = async (email: string): Promise<{ message: string }> => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/verifyEmail`, { email });
    return response.data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw new Error('Failed to send OTP');
  }
};

export const verifyOtpService = async (email: string, otp: string): Promise<{ message: string, code: number }> => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/verifyEmailOtp`, { email, otp });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw new Error('Failed to verify OTP');
  }
};

